/**
 * Errors reach the app's error handlers from several places — axios rejections,
 * yup ValidationErrors, and the occasional bare value a mutation rejected with —
 * so read the fields we care about without asserting a shape on them.
 */
const readProp = (value: unknown, key: string): unknown =>
  typeof value === "object" && value !== null
    ? (value as Record<string, unknown>)[key]
    : undefined;

/** The HTTP status of a failed request, or undefined if the error has none. */
export const httpStatus = (error: unknown): number | undefined => {
  const status = readProp(readProp(error, "response"), "status");
  return typeof status === "number" ? status : undefined;
};

/** An error's `code` (axios uses string codes like ERR_NETWORK; some APIs use numbers). */
export const errorCode = (error: unknown): unknown => readProp(error, "code");
